import {
    AllocateIcon,
    AuditTrail,
    BookIcon,
    CalculatorIcon,
    ComputeUploadIcon,
    DefineIcon,
    DocumentIcon,
    DownloadSidebarIcon,
    HomeIcon,
    PremiumIcon,
    PrepareIcon,
    ReturnIcon,
    SelfServiceIcon,
    UserGroupIcon,
} from '@/assets/icons'
import { MTIconProps } from '@/multi-territory/mt-types/mt-shared'
import { ComponentType } from 'react'

export const MTIconMap: Record<string, ComponentType<MTIconProps>> = {
  // Sidebar icons — supports both simple keys and API "-icon" suffix variants
  home: HomeIcon as ComponentType<MTIconProps>,
  dashboard: HomeIcon as ComponentType<MTIconProps>,
  'dashboard-icon': HomeIcon as ComponentType<MTIconProps>,
  user: UserGroupIcon as ComponentType<MTIconProps>,
  admin: UserGroupIcon as ComponentType<MTIconProps>,
  'admin-icon': UserGroupIcon as ComponentType<MTIconProps>,
  document: ReturnIcon as ComponentType<MTIconProps>,
  file: ReturnIcon as ComponentType<MTIconProps>,
  'returns-icon': ReturnIcon as ComponentType<MTIconProps>,
  book: BookIcon as ComponentType<MTIconProps>,
  layers: BookIcon as ComponentType<MTIconProps>,
  'provision-icon': BookIcon as ComponentType<MTIconProps>,
  download: DownloadSidebarIcon as ComponentType<MTIconProps>,
  'download-icon': DownloadSidebarIcon as ComponentType<MTIconProps>,
  premium: PremiumIcon as ComponentType<MTIconProps>,
  'premium-icon': PremiumIcon as ComponentType<MTIconProps>,
  audit: AuditTrail as ComponentType<MTIconProps>,
  'audit-icon': AuditTrail as ComponentType<MTIconProps>,
  'audit-trail': AuditTrail as ComponentType<MTIconProps>,
  'self-service': SelfServiceIcon as ComponentType<MTIconProps>,
  'self-service-icon': SelfServiceIcon as ComponentType<MTIconProps>,
  // Returns workflow step icons
  define: DefineIcon as ComponentType<MTIconProps>,
  upload: ComputeUploadIcon as ComponentType<MTIconProps>,
  prepare: PrepareIcon as ComponentType<MTIconProps>,
  compute: CalculatorIcon as ComponentType<MTIconProps>,
  allocate: AllocateIcon as ComponentType<MTIconProps>,
  returns: DocumentIcon as ComponentType<MTIconProps>,
  reports: DocumentIcon as ComponentType<MTIconProps>,
}
